// LA MARQUE, DANS LA PAGE.
//
// Un <svg> EN LIGNE et pas un <img src="/logo.svg">, pour une raison et une seule : les tracés
// disent `currentColor`. En ligne, la marque prend la couleur du texte qui l'entoure et suit donc
// le thème clair comme sombre sans une ligne de CSS. Dans un <img>, le dessin est un document à
// part — `currentColor` y retomberait sur le noir du navigateur, et la marque disparaîtrait sur
// un fond sombre.
//
// Les courbes viennent de lib/logo_mark, engendré depuis le dessin relevé sur getperimetr.com.
// Elles ne sont PAS recopiées ici : trois copies d'un même dessin dérivent, c'est le défaut de
// `theme.json` sous un autre visage.
import { LOGO_D, LOGO_STROKE, LOGO_VIEWBOX } from "../lib/logo_mark";

/**
 * La marque getperimetr.
 *
 * `aria-hidden` par défaut, et c'est le bon défaut : elle est toujours posée À CÔTÉ du mot
 * « getperimetr », donc l'annoncer une seconde fois ferait entendre le nom deux fois à qui écoute
 * la page. `label` la rend annonçable pour le cas où elle tiendrait seule.
 */
export function Logo({ className, label }: { className?: string; label?: string }) {
  return (
    <svg
      viewBox={LOGO_VIEWBOX}
      className={className}
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
      /* `overflow: visible` : le site le pose, et sans lui les bouts arrondis des courbes les plus
         larges seraient rognés au bord du repère. */
      style={{ overflow: "visible" }}
    >
      <g>
        {LOGO_D.map((d) => <path key={d} d={d} {...LOGO_STROKE} />)}
      </g>
    </svg>
  );
}
